import React, { useState, useEffect } from 'react'
import { Row, Col, Button, Image, Divider, Tag, Typography } from 'antd';
import { Avatar, Card } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, FormOutlined } from '@ant-design/icons';
import { API, IMAGE_API, usuario } from '../../resources';
import Loading from '../../loading';
import PerfilEdit from './perfil.edit';

export default function PerfilAdministrador() {

  const [profileData, setProfileData] = useState([]);
  const [editing, setEditing] = useState(false)
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { getProfileData() }, [])
  useEffect(() => { getProfileData() }, [editing])

  const getProfileData = () => {
    fetch(API + 'userByMail/' + usuario.email)
      .then(response => response.json())
      .then(data => {
        setProfileData(data[0]);
        setIsLoading(false);
      });
  }

  const editPerfil = (p) => {
    p.horarios.forEach((h) => { h.sucursal = h.sucursal._id })
    setEditing(true);
  }

  const DetailsProfile = () => (
    <Row gutter={[48, 32]}>
      <Col xs={24} md={10} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        {profileData.avatar.length > 9
          ? <Image style={{ borderRadius: '50%', objectFit: 'cover' }} width={160} height={160} src={IMAGE_API + profileData.avatar} />
          : <Avatar size={160} icon={<UserOutlined />} className='btnIconCentered' />
        }
        <div style={{ height: 16 }} />
        <p className='nombre'>{profileData.name}</p>
        <Tag color="blue" style={{ marginBottom: 8 }}>{profileData.rol}</Tag>
        <Divider style={{ margin: '12px 0' }} />
        <div style={{ textAlign: 'center', width: '100%' }}>
          <p className='datos'><MailOutlined style={{ marginRight: 8 }} />{profileData.email}</p>
          <p className='datos'><PhoneOutlined style={{ marginRight: 8 }} />{profileData.telefono}</p>
        </div>
      </Col>

      <Col xs={24} md={14}>
        <Card title='Horarios' style={{ borderRadius: 12 }}>
          {profileData.horarios.map((h, i) => (
            <Card.Grid key={i} style={{ width: '100%' }}>
              <Row align="middle" gutter={16}>
                <Col flex="80px" style={{ display: 'flex', justifyContent: 'center' }}>
                  <img width={56} src={h.sucursal.logo && h.sucursal.logo.length ? IMAGE_API + h.sucursal.logo : IMAGE_API + 'noimg.jpg'} alt="Logo" style={{ objectFit: 'contain' }} />
                </Col>
                <Col flex="auto">
                  <p className='datos' style={{ margin: 0 }}>{h.sucursal.nombre}</p>
                  <p className='subdesc' style={{ margin: 0 }}>{h.horario}</p>
                </Col>
              </Row>
            </Card.Grid>
          ))}
        </Card>
      </Col>
    </Row>
  )

  return (
    <div style={{ padding: '24px', background: '#f5f7fa', minHeight: '100vh' }}>
      <Card
        title={
          <div style={{ display: 'flex', flex: 1, alignItems: 'center', gap: '12px' }}>
            <div style={{ padding: '10px', background: '#e6f4ff', borderRadius: '10px', display: 'flex' }}>
              <UserOutlined style={{ fontSize: '24px', color: '#1677ff' }} />
            </div>
            <Typography.Title level={3} style={{ margin: 0, color: '#1f1f1f' }}>Perfil</Typography.Title>
          </div>
        }
        extra={
          !editing && !isLoading &&
          <Button onClick={() => editPerfil(profileData)} type='primary' shape='circle' icon={<FormOutlined />} className='btnIconCentered' />
        }
        bordered={false}
        style={{ borderRadius: '16px', boxShadow: '0 4px 24px -8px rgba(0,0,0,0.05)' }}
      >
        {isLoading
          ? <Loading />
          : editing
            ? <>
                <PerfilEdit perfil={profileData} setEditing={setEditing} />
                <Button style={{ marginTop: 12 }} onClick={() => setEditing(false)}>Cancelar</Button>
              </>
            : <DetailsProfile />
        }
      </Card>
    </div>
  )
}
